<div class="gift-card-selection">
  <p class="gift-card-selection__prompt">{{ 'payment.multipleGiftCardsFound' | transloco }}</p>
  <ion-list>
    <ion-item *ngFor="let card of giftCards"
              button
              lines="full"
              [class.gift-card-selection__item--selected]="selectedCard === card"
              debounce-click
              [debounceTime]="0"
              (debounceClick)="onSelectCard(card)">
      <ion-label>
        <p class="gift-card-selection__balance">{{ 'payment.balance' | transloco }}: <b>{{ card.balance | currency }}</b></p>
        <p *ngIf="card.facility_name">{{ card.facility_name }}</p>
        <p *ngIf="card.profile_name">{{ card.profile_name }}</p>
        <p *ngIf="card.profile_facility_name">{{ card.profile_facility_name }}</p>
      </ion-label>
      <ion-icon *ngIf="selectedCard === card"
                name="checkmark-circle"
                color="orange"
                slot="end"></ion-icon>
    </ion-item>
  </ion-list>
</div>
